/**
 * Utility functions for property list filtering
 */

/**
 * Initialize filters from URL query parameters
 * @param {string} searchParams - URL search string (e.g., "?city=Ponce&bedrooms=3")
 * @param {Array<string>} filterKeys - Array of filter keys to extract from URL params
 * @returns {Object} Filter object with extracted values or empty strings
 */
export const initializeFiltersFromURL = (searchParams, filterKeys) => {
  const params = new URLSearchParams(searchParams);
  const filters = {};
  
  filterKeys.forEach(key => {
    filters[key] = params.get(key) || '';
  });
  
  return filters;
};

/**
 * Get filter keys for for-sale properties
 */
export const FOR_SALE_FILTER_KEYS = [
  'status',
  'propertyType',
  'minPrice',
  'maxPrice',
  'isReposeida',
  'city',
  'bedrooms',
  'bathrooms',
];

/**
 * Get filter keys for for-rent properties
 */
export const FOR_RENT_FILTER_KEYS = [
  'status',
  'propertyType',
  'minPrice',
  'maxPrice',
  'city',
  'bedrooms',
  'bathrooms',
];

/**
 * Get filter keys for sold properties
 */
export const SOLD_FILTER_KEYS = [
  'propertyType',
  'minPrice',
  'maxPrice',
  'isReposeida',
  'city',
  'bedrooms',
  'bathrooms',
];
